var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNoteRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M11.25 3h-7.5c-.825 0-1.5.675-1.5 1.5v9.008c0 .825.675 1.492 1.5 1.492l10.5-.008c.825 0 1.5-.667 1.5-1.492v-6L11.25 3zm4.125 5.25H11.25V4.125l4.125 4.125z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#B4B4B4",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 0 18)",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoteRoom);
export default __webpack_public_path__ + "static/media/ic_note_room.ec77a7e4e67f72ecc9b132211ffa8384.svg";
export { ForwardRef as ReactComponent };